<template>
	<div class="draggable-list">
		<div class="draggable-list__header" v-if="title">
			<div class="draggable-list__header-title"> {{ title }} </div>
			<div class="draggable-list__header-sub-heading" v-if="subHeading">
				{{ subHeading }}
			</div>
		</div>

		<Draggable
			v-model="arrayVal"
			class="draggable-list__items"
			handle=".draggable-item__icon"
			v-bind="dragOptions"
			:tag="tag"
			@start="drag = true"
			@end="drag = false"
			@change="onChange"
		>
			<transition-group
				class="draggable-list__transition-group"
				type="transition"
				tag="ol"
				:name="!drag ? 'transition-transform-movement' : null"
			>
				<slot />
			</transition-group>
		</Draggable>
		<slot name="footer" />
	</div>
</template>

<script>
import Draggable from 'vuedraggable';

export default {
	name: 'DraggableListOrder',
	components: {
		Draggable
	},
	model: {
		value: 'value',
		event: 'change'
	},
	props: {
		/**
		 * HTML tag of the parent element
		 */
		title: {
			type: String,
			default: ''
		},
		subHeading: {
			type: String,
			default: ''
		},
		tag: {
			type: String,
			default: 'div'
		},
		value: {
			type: Array,
			required: false
		},
		// provides a name for the draggable group, draggable items with the same group name can be moved between draggable lists
		groupName: {
			type: String,
			default: 'list-elements'
		}
	},
	data() {
		return {
			drag: false,
			arrayVal: this.value
		};
	},
	computed: {
		dragOptions() {
			return {
				animation: 200,
				group: this.groupName,
				disabled: false,
				ghostClass: 'is-ghost',
				chosenClass: 'is-sortable-chosen'
			};
		}
	},
	methods: {
		onChange() {
			// this.$emit('input', this.arrayVal);
			this.$emit('change', this.arrayVal);
		}
	},
	watch: {
		value: {
			deep: true,
			immediate: true,
			handler(arr) {
				this.arrayVal = arr;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.draggable-list {
	&__header {
		display: flex;
		flex-direction: column;
		padding-bottom: $padding-sm;
		border-bottom: 1px solid $neutral-3;
		margin-bottom: $gutter-xl;
	}

	&__header-title {
		@include heading('lg');
	}

	&__header-sub-heading {
		@include sub-heading;
	}

	&__items {
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	&__transition-group {
		margin-block-start: 0;
		margin-block-end: 0;
		margin-inline-start: 0;
		margin-inline-end: 0;
		padding-inline-start: 0;
		display: flex;
		flex-direction: column;
		gap: $gutter-lg;
	}
}

@include transition-transform-movement;
</style>
